import Strongest from './Strongest'
import enhance from './enhancers'
import strongestTheme from './theme.scss'

export {
  Strongest,
  enhance,
  strongestTheme as theme
}

export default enhance(Strongest)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Strongest/index.js